import Swal from 'sweetalert2';

// Wrapper global com estilos Bootstrap
// Uso: import swal from '.../utils/swal';  =>  await swal.fire({...})
const swal = Swal.mixin({
  customClass: {
    confirmButton: 'btn btn-primary mr-3',
    cancelButton: 'btn btn-secondary mr-3',
  },
  buttonsStyling: false,
});

export default swal;
export { Swal };
